var exports = {
  "J": "Confetti.module__canvas___LVFfMn",
};

module.exports = exports;
